export default "__VITE_ASSET__DfICJEx4__"